/** The NAM/IR format label used on tone cards, tone pages and the sub-nav. */
const FormatPill = ({ format }: { format?: string | null }) => {
  // A tone with no format would otherwise render an empty pill.
  if (!format) return null;

  return (
    <p className="bg-zinc-400 text-black text-xs font-mono px-[4px] py-[0px] sm:px-[6px] sm:py-[1px] rounded-sm whitespace-nowrap">
      {format.toUpperCase()}
    </p>
  );
};

export default FormatPill;
